/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCheckoutPageResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CheckoutPageResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/checkout-page
 */
export interface CheckoutPageRequestBuilder extends BaseRequestBuilder<CheckoutPageRequestBuilder> {
    /**
     * Gets the checkout page for the Organization. An organization that already has a subscription is returned a self-service portal URL instead, with Type set to 'portal_session'.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CheckoutPageResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<CheckoutPageRequestBuilderGetQueryParameters> | undefined) : Promise<CheckoutPageResponse | undefined>;
    /**
     * Gets the checkout page for the Organization. An organization that already has a subscription is returned a self-service portal URL instead, with Type set to 'portal_session'.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CheckoutPageRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Gets the checkout page for the Organization. An organization that already has a subscription is returned a self-service portal URL instead, with Type set to 'portal_session'.
 */
export interface CheckoutPageRequestBuilderGetQueryParameters {
    /**
     * Optional add-on item price ids, e.g. storefront_addon_monthly. Each is added at quantity 1;the current add-ons are all flat-fee.
     */
    addonItemPriceIds?: string[];
    /**
     * Item price id of the plan being subscribed to, e.g. sales_plan_monthly orstorefront_standalone_monthly.
     */
    planItemPriceId?: string;
    /**
     * How many units of the plan to buy. Plans priced per unit charge per rep, so this is the rep count;flat-fee plans ignore it and should send 1. Defaults to 1 rather than 0, because a checkout fornothing is never what the caller meant.
     */
    quantity?: number;
}
/**
 * Uri template for the request builder.
 */
export const CheckoutPageRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/checkout-page?addonItemPriceIds={addonItemPriceIds}&planItemPriceId={planItemPriceId}&quantity={quantity}";
/**
 * Metadata for all the requests in the request builder.
 */
export const CheckoutPageRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CheckoutPageRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCheckoutPageResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
